<div class="p-8">
  <div class="flex justify-between items-center mb-4">
    <h1 class="text-2xl font-bold">Sites</h1>
    @if (auth.isPlatformAdmin$ | async) {
      <button
        (click)="openAddSiteModal()"
        class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
        Add Site
      </button>
    }
  </div>

  @if (successMessage) {
    <div class="mb-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded">
      {{ successMessage }}
    </div>
  }

  @if (errorMessage) {
    <div class="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
      {{ errorMessage }}
    </div>
  }

  <app-spinner *ngIf="loading"></app-spinner>

  <div *ngIf="!loading" class="space-y-4">
    @for (site of sites; track site) {
      <div class="bg-white border p-4 rounded-lg shadow flex justify-between items-center">
        <div class="flex items-center gap-4">
          <div *ngIf="site.client?.logo?.src" class="h-8 flex items-center flex-shrink-0">
            <div *ngIf="isSvgMarkup(site.client.logo.src)" [innerHTML]="sanitizeSvg(site.client.logo.src)" class="[&>svg]:h-8 [&>svg]:w-auto"></div>
            <img *ngIf="!isSvgMarkup(site.client.logo.src)" [src]="site.client.logo.src" alt="Logo" class="h-8 w-auto object-contain">
          </div>
          <div>
            <h3 class="font-semibold">{{ site.client.name }}</h3>
            <p class="text-gray-600">{{ site.url }}</p>
          </div>
        </div>
        <div class="flex space-x-2">
          <a [routerLink]="['/sites', site.url, 'manage']" class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
            Manage
          </a>
        </div>
      </div>
    }
  </div>
</div>

<div *ngIf="showModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg max-w-4xl w-full mx-4 max-h-[90vh] overflow-y-auto">
    <div class="p-6">
      <h2 class="text-xl font-bold mb-4">Add New Site</h2>
      <app-site-form
        [isEdit]="false"
        (formSubmit)="onSiteCreated()"
        (formCancel)="closeModal()"
        (success)="onSuccess($event)"
        (error)="onError($event)">
      </app-site-form>
    </div>
  </div>
</div>

<app-confirmation-modal
  [show]="showDeleteModal"
  title="Delete Site"
  message="Are you sure you want to delete this site? This action cannot be undone."
  confirmText="Delete"
  cancelText="Cancel"
  (confirm)="confirmDelete()"
  (cancel)="cancelDelete()">
</app-confirmation-modal>
